// tb_api-zendesk.js


const BASE = 'https://tbf-cd446fc00dcd.herokuapp.com/api/zendesk';
let uploadedTokens = [];
let uploadedFileNames = [];

const FORM_PARAM = 'form';

function getFormIdFromURL() {
  const url = new URL(location.href);
  const v = url.searchParams.get(FORM_PARAM);
  if (!v) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function setFormIdInURL(formId, { replace = false } = {}) {
  const url = new URL(location.href);
  if (!formId) {
    url.searchParams.delete(FORM_PARAM);
  } else {
    url.searchParams.set(FORM_PARAM, String(formId));
  }
  if (replace) history.replaceState({}, '', url);
  else history.pushState({}, '', url);
}


/** 
 * Muestra un error al final del .field-group usando raw_title
 */
function showError(el, message) {
  clearError(el);
  el.style.borderColor = '#c53030';
  const error = document.createElement('div');
  error.className = 'error-message';
  error.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" focusable="false"
         viewBox="0 0 16 16" aria-label="error" role="img">
      <g fill="none" stroke="currentColor">
        <circle cx="7.5" cy="8.5" r="7"></circle>
        <path stroke-linecap="round" d="M7.5 4.5V9"></path>
      </g>
      <circle cx="7.5" cy="12" r="1" fill="currentColor"></circle>
    </svg>
    <span style="color:#c53030; margin-left:4px;">${message}</span>
  `;
  const fg = el.closest('.field-group') || el.parentNode;
  fg.appendChild(error);
}

/**
 * Limpia el error
 */
function clearError(el) {
  el.style.borderColor = '';
  const fg = el.closest('.field-group') || el.parentNode;
  const old = fg.querySelector('.error-message');
  if (old) old.remove();
}

/**
 * Extrae raw_title para el mensaje
 */
function getRawTitle(el) {
  return el.dataset.rawTitle || el.getAttribute('name') || 'Este campo';
}

/**
 * Pantalla de éxito
 */
function showSuccess() {
  const form = document.getElementById('ContactForm');
  form.style.display = 'none';
  const c = document.createElement('div');
  c.className = 'success-container';
  c.innerHTML = `
    <div style="display:flex; align-items:center; gap:8px; margin-bottom:16px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" focusable="false"
           viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9 12l2 2l4 -4"></path>
      </svg>
      <h2 style="margin:0; font-size:2.25rem;">Tu consulta ha sido realizada.</h2>
    </div>
    <p>Responderemos en 24/48 horas laborales. Recibirás un email de confirmación, en caso de necesitar ampliar información por favor contesta a ese mismo email. ¡Gracias!</p>
  `;
  form.parentNode.insertBefore(c, form.nextSibling);
}

/**
 * Pantalla de error al enviar ticket
 */
function showTicketError() {
  const form = document.getElementById('ContactForm');
  form.style.display = 'none';
  const c = document.createElement('div');
  c.className = 'error-container';
  c.innerHTML = `
   <div style="display:flex; align-items:center; gap:8px; margin-bottom:16px;">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" focusable="false"
         viewBox="0 0 24 24" fill="none" stroke="#d32f2f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>
    <h2 style="margin:0; font-size:2.25rem;">Lo sentimos, ha ocurrido un problema al procesar tu petición.</h2>
  </div>
  <p>Vuelve a intentarlo dentro de unos minutos o envía toda la información solicitada a <a href="mailto:soporte@thebath.es">soporte@thebath.es</a></p>
  `;
  form.parentNode.insertBefore(c, form.nextSibling);
}

/** 🚀 Arranca */
document.addEventListener('DOMContentLoaded', () => {
  getTicketsForms();
  document.getElementById('ContactForm-select')
          .addEventListener('change', onFormChange);
});

/**
 * 1) Carga listado de formularios
 */
async function getTicketsForms() {
  const locale = Shopify.locale;
 
  const res = await fetch(`${BASE}/zendesk-process-form?locale=${locale}&action=loadForms`);
  if (!res.ok) throw new Error(`Error cargando forms: ${res.status}`);
  const forms = await res.json();
  const sel = document.getElementById('ContactForm-select');
  
  forms.forEach(f => {
    const o = document.createElement('option');
    o.value = f.id;
    o.textContent = f.display_name;
    sel.appendChild(o);
  });

  // 1) Si la URL trae ?form=..., intentamos seleccionarlo
  const urlFormId = getFormIdFromURL();
  if (urlFormId && [...sel.options].some(o => Number(o.value) === urlFormId)) {
    sel.value = String(urlFormId);
    // Renderiza el formulario seleccionado
    await onFormChange({ target: sel });
    // Asegura que el parámetro queda normalizado (por si venía mal formateado)
    setFormIdInURL(urlFormId, { replace: true });
  } else {
    // Si había un ?form inválido, lo limpiamos para evitar estados raros
    if (urlFormId && sel.value === '') setFormIdInURL(null, { replace: true });
  }

  // 2) Soporta navegación atrás/adelante
  window.addEventListener('popstate', async () => {
    const id = getFormIdFromURL();
    if (id && [...sel.options].some(o => Number(o.value) === id)) {
      sel.value = String(id);
      await onFormChange({ target: sel });
    } else {
      // Si ya no es válido, resetea UI
      sel.value = '';
      const cont = document.getElementById('form-dynamic');
      cont.innerHTML = '';
      cont.classList.remove('loaded', 'fade-in');
      document.getElementById('contact-btn').style.display = 'none';
    }
  });
}
/**
 * Genera N “huecos” de skeleton en el contenedor
 */
function mostrarSkeleton(container, fieldsCount) {
  container.innerHTML = '';
  for (let i = 0; i < fieldsCount; i++) {
    const s = document.createElement('div');
    s.className = 'skeleton';
   


    container.appendChild(s);
  }
}

  
/**
 * 2) Al seleccionar formulario
 */
async function onFormChange(e) {
  const formId = parseInt(e.target.value, 10);
  
  if (isNaN(formId)) {
    setFormIdInURL(null); // quita ?form si vuelves al placeholder
  } else {
    setFormIdInURL(formId); // pushState (crea historial)
  }

  const locale = Shopify.locale;
  const btn    = document.getElementById('contact-btn');
  const cont   = document.getElementById('form-dynamic');

  // ————— Limpia y muestra skeletons —————
  cont.innerHTML = '';
  cont.classList.remove('loaded');           
  if(formId){
     mostrarSkeleton(cont, 10);   
  }
          

  // Reinicia cualquier upload anterior
  uploadedTokens = [];
  uploadedFileNames = [];

  // Si no hay formulario seleccionado, oculta botón y sale
  if (isNaN(formId)) {
    btn.style.display = 'none';
    return;
  }

  try {
    // —— 1) Pide los campos dinámicos ——
    const res = await fetch(
      `${BASE}/zendesk-process-form?formType=${formId}&locale=${locale}&action=loadInputs`
    );
    if (!res.ok) throw new Error(`Error cargando campos: ${res.status}`);
    const fields = await res.json();

    // —— 2) Limpia skeletons e inyecta formulario ——
    cont.innerHTML = '';
    renderData(fields, formId);

    // —— 3) Aplica fade-in suave ——
   cont.classList.add('fade-in');
    requestAnimationFrame(() => {
        cont.classList.add('loaded');
    });

    // —— 4) Lógica extra para “Pedido” (GraphQL + cantidad) ——
    const orderSelect = document.getElementById('order-select');
    
    
if(orderSelect != null){
  
   /* Añadir mensaje para que inicien sesión para ver su historial de pedidos */
    let currentUrl = window.location.pathname + window.location.search;
    let encoded = encodeURIComponent(currentUrl);
     const spanLabel = locale.startsWith('pt') ? `<span style="font-size:small;">Para ver o seu histórico de encomendas <a href="/account/login?return_to=${encoded}">inicie sessão.</a></span>`
                     : locale.startsWith('fr') ? `<span style="font-size:small;">Pour consulter l'historique de vos commandes <a href="/account/login?return_to=${encoded}">connectez-vous.</a></span>`
                     : `<span style="font-size:small;">Para ver tu historial de pedidos <a href="/account/login?return_to=${encoded}">inicia sesión.</a></span>`;
    let orderMessage = spanLabel;

     isLogged ? "" : cont.insertAdjacentHTML("afterbegin", orderMessage);


    
   

}

   


    if (orderSelect && formId === 24184638705553) {
      orderSelect.addEventListener('change', async e => {
        const orderId = e.target.selectedOptions[0].dataset.orderId;
  const shop = Shopify.shop;
        try {
          // 4.1) Fetch graphql de líneas de pedido
          const resp = await fetch(`${BASE}/getproducts?shop=${shop}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ orderId })
          });
          if (!resp.ok) {
            const { error } = await resp.json();
            throw new Error(error || `HTTP ${resp.status}`);
          }
          const { lines } = await resp.json();

          // 4.2) Maneja el select de tipo de reembolso
          const refundType = document.querySelector('[data-zd-id="24189540987665"]');
          refundType.addEventListener('change', () => {
            // Elimina wrapper previo si existía
            const prev = document.getElementById('tb_quantity-wrapper');
            if (prev) prev.remove();

            if (refundType.value === 'algunos_productos') {
              // Crea contenedor de cantidades
              const wrapper = document.createElement('div');
              wrapper.id = 'tb_quantity-wrapper';
              Object.assign(wrapper.style, {
                margin: '0.5em 0',
                padding: '6px',
                maxHeight: '240px',
                overflow: 'auto'
              });
              refundType.insertAdjacentElement('afterend', wrapper);

              // Por cada línea, crea label + botones + input
              lines.forEach(({ name, quantity }) => {
                const label = document.createElement('label');
                Object.assign(label.style, {
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  margin: '0.4em 0'
                });

                const spanName = document.createElement('span');
                spanName.textContent = `${name} (${quantity} ud.)`;

                const qtyWrapper = document.createElement('div');
                Object.assign(qtyWrapper.style, {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5em'
                });

                const btnMinus = document.createElement('button');
                btnMinus.type = 'button';
                btnMinus.textContent = '−';
                btnMinus.className = 'qty-btn';

                const qtyInput = document.createElement('input');
                Object.assign(qtyInput, {
                  type: 'number',
                  name: 'cantidad_devolucion[]',
                  value: 0,
                  min: 0,
                  max: quantity,
                  step: 1,
                  id: `qty_${name.replace(/\s+/g, '_')}`
                });
                qtyInput.dataset.productName = name;
                Object.assign(qtyInput.style, {
                  width: '3em',
                  margin: '0',
                  border: 'none',
                  background: 'transparent',
                  textAlign: 'center',
                  MozAppearance: 'textfield',
                  WebkitAppearance: 'none'
                });

                const btnPlus = document.createElement('button');
                btnPlus.type = 'button';
                btnPlus.textContent = '+';
                btnPlus.className = 'qty-btn';

                // Función para habilitar/deshabilitar botones
                function updateButtons() {
                  const v = parseInt(qtyInput.value, 10) || 0;
                  btnMinus.disabled = v <= 0;
                  btnPlus.disabled  = v >= quantity;
                }

                btnMinus.addEventListener('click', () => {
                  qtyInput.value = Math.max(0, (parseInt(qtyInput.value, 10) || 0) - 1);
                  updateButtons();
                });
                btnPlus.addEventListener('click', () => {
                  qtyInput.value = Math.min(quantity, (parseInt(qtyInput.value, 10) || 0) + 1);
                  updateButtons();
                });

                qtyWrapper.append(btnMinus, qtyInput, btnPlus);
                label.append(spanName, qtyWrapper);
                wrapper.appendChild(label);

                updateButtons();
              });
            }
          });
        } catch (err) {
          console.error('Error GraphQL o de red:', err);
        }
      });
    }

    // —— 5) Muestra botón de enviar y asigna handler ——
    btn.style.display = 'block';
    btn.onclick = submitForm;
  }
  catch (err) {
    console.error('Falló onFormChange:', err);
    // En caso de error, limpia skeletons y muestra mensaje
    cont.innerHTML = '<p>Error al cargar el formulario.</p>';
    cont.classList.add('loaded');
    btn.style.display = 'none';
  }
}

/**
 * 3) Renderiza campos + uploader
 */
function renderData(fields, formId) {
  const cont = document.getElementById('form-dynamic');
  const targetForms = [27273281478417, 24184638705553, 9775380576017, 27278985556113];
  const orderMap = {
    360000245698: ['email', 9775606195345, 360006901838, 360025126238],
    27273281478417: ['email', 14808453025553, 360007286437,360010737778, 24185696420241, 360006901838, 360025126238, 9776128590993],
    24184638705553: ['email', 360007286437, 24185253841297, 24185515440657, 24185666030609, 24189540987665, 360006901838, 24185696420241, 360025126238],
    9775380576017: ['email', 360007286437, 9775606195345, 360006901838, 9776128590993, 360025126238],
    27278985556113: ['email', 360007286437, 360006901838, 360025126238],
  };
  let seq = orderMap[formId] || [];
  if (!seq.length) seq = ['email', ...fields.map(f => f.id)];

  // Campo Email
  if (seq.includes('email')) {
    let emailCustomer;
    
   if(customer_email != undefined){
     emailCustomer = customer_email;
   }else{
     emailCustomer = "";
   }
    
    const locale = Shopify.locale || 'es';
    const emailLabel = locale.startsWith('pt') ? 'Endereço eletrónico'
                     : locale.startsWith('fr') ? 'Adresse électronique'
                     : 'Correo electrónico';
    const wrap = document.createElement('div');
    wrap.className = 'grid-col-12 mt-2';
    wrap.innerHTML = `
      <p style="font-weight:bold">${emailLabel}*</p>
      <p></p>
      <input type="email" name="email" class="field__input tb_input" value="${emailCustomer}" required
             data-required-portal="true" data-raw-title="${emailLabel}">
    `;
    
    cont.appendChild(wrap);
  }

  // Resto de campos dinámicos
  fields
    .filter(f => f.visible_in_portal && seq.includes(f.id))
    .sort((a, b) => seq.indexOf(a.id) - seq.indexOf(b.id))
    .forEach(f => {
      const wrap = document.createElement('div');
      wrap.className = 'grid-col-12 mt-2';

      // checkbox
      if (f.type === 'checkbox') {
        wrap.classList.add('checkbox-field');
        const p = document.createElement('p');
        p.style.fontWeight = 'bold';
        const cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.name = `campo_${f.id}`;
        cb.className = 'field__input_check tb_input';
        cb.required = f.required_in_portal;
        cb.dataset.requiredPortal = f.required_in_portal;
        cb.dataset.rawTitle = f.title_in_portal;
        cb.setAttribute('data-zd-id', f.id);
        cb.setAttribute('data-zd-type', 'checkbox');
        p.append(cb, document.createTextNode(' ' + f.title_in_portal + (f.required_in_portal ? '*' : '')));
        wrap.appendChild(p);
        if (f.description) {
          const pd = document.createElement('p');
          pd.textContent = f.description;
          wrap.appendChild(pd);
        }
        cont.appendChild(wrap);
        return;
      }
    
      // override pedido select
      if (f.id === 360007286437 && targetForms.includes(Number(formId))) {
        wrap.innerHTML = `
          <p style="font-weight:bold">${f.title_in_portal}*</p>
         
        `;

        if(window.customerOrders != undefined && window.customerOrders.length > 0){
            const sel = document.createElement('select');
        sel.name = `campo_${f.id}`;
        sel.className = 'field__input tb_input  form-select';
        sel.required = true;
        sel.dataset.requiredPortal = 'true';
        sel.dataset.rawTitle = f.title_in_portal;
        sel.setAttribute('data-zd-id', f.id);
        sel.setAttribute('data-zd-type', f.type);
        const defaultOpt = document.createElement('option');
        defaultOpt.value = '';
        const locale = Shopify.locale || 'es';
        defaultOpt.textContent = locale.startsWith('pt')
                              ? '-Selecionar a ordem-'
                              : locale.startsWith('fr')
                                ? '-Sélectionner la commande-'
                                : '-Seleccione el pedido-';
        sel.appendChild(defaultOpt);
        const orders = Array.isArray(window.customerOrders) ? window.customerOrders : [];
        orders.forEach(order => {
          const clean = order.name.replace(/[#()]/g, '').trim();
          const opt = document.createElement('option');
          opt.value = clean;
          opt.textContent = clean;
          opt.dataset.orderId = order.id;
          sel.appendChild(opt);
        });
        sel.id = 'order-select';
        wrap.appendChild(sel);
        cont.appendChild(wrap);
        }else{
          const sel = document.createElement('input');
        sel.name = `campo_${f.id}`;
        sel.className = 'field__input tb_input';
        sel.required = true;
        sel.dataset.requiredPortal = 'true';
        sel.dataset.rawTitle = f.title_in_portal;
        sel.setAttribute('data-zd-id', f.id);
        sel.setAttribute('data-zd-type', f.type);
        sel.type = "text";
        sel.id = 'order-select';
        wrap.appendChild(sel);
        cont.appendChild(wrap);
        }
      
        return;
      }

      // tagger, textarea, date, number, text
      wrap.innerHTML = `
        <p style="font-weight:bold">${f.title_in_portal}${f.required_in_portal ? '*' : ''}</p>
        <p>${f.description || ''}</p>
      `;
      let el;
      switch (f.type) {
        case 'tagger':
          el = document.createElement('select');
          el.innerHTML = '<option value=""></option>' +
            f.custom_field_options.map(o => `<option value="${o.value}">${o.name}</option>`).join('');
          break;
        case 'description':
          el = document.createElement('textarea');
          break;
        case 'date':
          el = document.createElement('input');
          el.type = 'date';
          break;
        case 'integer':
          el = document.createElement('input');
          el.type = 'number';
          break;
        default:
          el = document.createElement('input');
          el.type = 'text';
      }
      el.name = `campo_${f.id}`;
      el.className = 'field__input tb_input form-select';
      el.required = f.required_in_portal;
      el.dataset.requiredPortal = f.required_in_portal;
      el.dataset.rawTitle = f.title_in_portal;
      el.setAttribute('data-zd-id', f.id);
      el.setAttribute('data-zd-type', f.type);

      wrap.appendChild(el);
      cont.appendChild(wrap);
    });

  // Subject & tags ocultos
  cont.insertAdjacentHTML('beforeend', `
    <input type="hidden" name="subject" data-zd-type="subject"
           value="${document.getElementById('ContactForm-select').selectedOptions[0].textContent}">
    <input type="hidden" name="tags" value="particular">
  `);

  // Uploader de archivos
  const locale2 = Shopify.locale || 'es';
  const attachmentsLabel = locale2.startsWith('pt') ? 'Anexos'
                         : locale2.startsWith('fr') ? 'Pièces jointes'
                         : 'Archivos adjuntos';
  const attachmentsPrompt = locale2.startsWith('pt') ? 'Escolher ou arrastrar ficheiro'
                         : locale2.startsWith('fr') ? 'Choisir ou faire glisser un fichier'
                         : 'Elegir o arrastrar archivo';
  cont.insertAdjacentHTML('beforeend', `
    <div class="grid-col-12 mt-2">
      <div class="field-group">
        <label style="font-weight:bold">${attachmentsLabel}</label>
        <div id="tb_drop_area" class="tb_drop">${attachmentsPrompt}</div>
        <input type="file" id="tb_file_input" accept="image/*,application/pdf" multiple hidden>
        <div id="tb_preview_area"></div>
      </div>
    </div>
  `);
  const drop = document.getElementById('tb_drop_area');
  const fileInput = document.getElementById('tb_file_input');
  drop.onclick    = () => fileInput.click();
  drop.ondragover = e => { e.preventDefault(); drop.classList.add('drag-over'); };
  drop.ondragleave= () => drop.classList.remove('drag-over');
  drop.ondrop     = async e => { e.preventDefault(); drop.classList.remove('drag-over'); await handleFiles(e.dataTransfer.files); };
  fileInput.onchange = async () => await handleFiles(fileInput.files);
}

async function handleFiles(files) {
  const preview = document.getElementById('tb_preview_area');
  const fileInput = document.getElementById('tb_file_input');
  for (const f of files) {
    if (!['image/jpeg','image/png','application/pdf'].includes(f.type)) continue;
    if (uploadedFileNames.includes(f.name)) continue;
    const url = f.type==='application/pdf'
      ? '/cdn/shop/t/13/assets/pdf.png'
      : URL.createObjectURL(f);
    const div = document.createElement('div');
    div.className = 'tb_preview_container';
    const thumb = document.createElement('div');
    thumb.className = 'tb_preview';
    const img = document.createElement('img');
    img.src = url;
    img.className = 'preview-image';
    const span = document.createElement('span');
    span.className = 'file-name';
    span.textContent = f.name;
    thumb.append(img, span);
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tb_remove';
    btn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path fill="none" stroke="currentColor" stroke-linecap="round"
          d="M6.5 2.5V1c0-.3.2-.5.5-.5h2c.3 0 .5.2.5.5v1.5M3 2.5h10m-6.5 11
             v-8m3 8v-8m-6-1V15c0 .3.2.5.5.5h8c.3 0 .5-.2.5-.5V4.5"/>
      </svg>`;
    div.append(thumb, btn);
    preview.appendChild(div);
    try {
      const token = await uploadFileToZendesk(f);
      div.dataset.token = token;
      uploadedTokens.push(token);
      uploadedFileNames.push(f.name);
    } catch (e) {
      console.error('Error subiendo', f.name, e);
    }
    btn.onclick = () => {
      div.remove();
      const tok = div.dataset.token;
      if (tok) uploadedTokens = uploadedTokens.filter(t => t !== tok);
      uploadedFileNames = uploadedFileNames.filter(n => n !== f.name);
    };
  }
  fileInput.value = '';
}

async function uploadFileToZendesk(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${BASE}/zendesk-upload?filename=${encodeURIComponent(file.name)}`, {
    method: 'POST', body: fd
  });
  if (!res.ok) throw new Error('Upload failed: '+res.status);
  return (await res.json()).token;
}

/**
 * 4) Valida según required_in_portal + email, crea *un* ticket
 */
async function submitForm() {
  const btn = document.getElementById('contact-btn');
  
  // 1) Deshabilitar botón y mostrar solo el spinner
  btn.disabled = true;
  btn.innerHTML = `<span class="button-spinner"></span>`;

  let hasError = false;
  // 2) Validación de email
  const emailEl = document.querySelector('#form-dynamic input[type="email"]');
  clearError(emailEl);
  const emailVal = emailEl.value.trim();
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailVal || !emailRe.test(emailVal)) {
    showError(emailEl, 'Correo electrónico: no puede estar en blanco o es inválido');
    hasError = true;
  }

  // 3) Validación del resto de campos obligatorios
  document.querySelectorAll('#form-dynamic [data-zd-id]').forEach(el => {
    clearError(el);
    if (el.dataset.requiredPortal === 'true') {
      const isChk = el.type === 'checkbox';
      const val = isChk ? (el.checked ? 'on' : '') : el.value.trim();
      if (!val) {
        showError(el, `${getRawTitle(el)}: no puede estar en blanco`);
        hasError = true;
      }
    }
  });

  if (hasError) {
    // Restaurar botón en caso de error
    btn.disabled = false;
    btn.textContent = 'Enviar';
    return;
  }

  // 4) Recoger productos a devolver
  const productosADevolver = Array.from(
    document.querySelectorAll('input[name="cantidad_devolucion[]"]')
  )
    .map(input => ({
      name: input.dataset.productName,
      quantity: parseInt(input.value, 10) || 0
    }))
    .filter(item => item.quantity > 0);

  // 5) Construir payload
  const tagsInput = document.querySelector('input[name="tags"]');
  const tags = tagsInput ? [tagsInput.value] : [];
  const data = {
    email: emailVal,
    subject: document.querySelector('[data-zd-type="subject"]').value,
    form_id: parseInt(document.getElementById('ContactForm-select').value, 10),
    description: document.querySelector('[data-zd-type="description"]')?.value.trim() || '',
    custom_fields: [],
    uploads: uploadedTokens,
    tags,
    productos: productosADevolver
  };

  // 6) Añadir custom_fields
  document.querySelectorAll('#form-dynamic [data-zd-id]').forEach(el => {
    const id = parseInt(el.getAttribute('data-zd-id'), 10);
    const type = el.getAttribute('data-zd-type');
    const val = type === 'checkbox' ? (el.checked ? 'true' : '') : el.value.trim();
    if (type !== 'description') {
      data.custom_fields.push({ id, value: val });
    }
  });

  // 7) Enviar petición
  try {
    const res = await fetch(`${BASE}/zendesk-process-form`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    const json = await res.json();

    if (!res.ok || json.error) {
      showTicketError();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      btn.disabled = false;
      btn.textContent = 'Enviar';
      return;
    }

    showSuccess();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } catch (err) {
    console.error('Fetch fallido:', err);
    showTicketError();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    btn.disabled = false;
    btn.textContent = 'Enviar';
  }
}


